import InfiniteScrollingListState from 'types/InfiniteScrollingListState.interface';
import InfiniteScrollingListStateHelper from 'utils/InfiniteScrollingList/InfiniteScrollingListStateHelper';

export interface IInfiniteScrollingListModalState extends InfiniteScrollingListState<any> {}

export const infiniteScrollingListModalState: IInfiniteScrollingListModalState = {
  ...InfiniteScrollingListStateHelper.initialState(),
};
